import type { AddProductToFavoriteButtonProps } from '@/feature/product/components/add-product-to-favorite-button/AddProductToFavoriteButton.client'
import type { WebViewIntent } from '@/lib/react-native/services/react-native.intent'
import { createIntent } from '@/lib/react-native/services/react-native.intent'

export function createFavoriteListProductAddedIntent(): WebViewIntent {
  // TODO: will change when toast is implemented on the mobile side
  // and when we know what kind of info needs ot be displayed
  return createIntent('FAVORITE_LIST_PRODUCT_ADDED')
}

export function createFavoriteListProductAddedFailedIntent(): WebViewIntent {
  // TODO: will change when toast is implemented on the mobile side
  // and when we know what kind of info needs ot be displayed
  return createIntent('FAVORITE_LIST_PRODUCT_ADDED_FAILED')
}

export function createFavoriteListAddProductDrawerCloseIntent(): WebViewIntent {
  return createIntent('FAVORITE_LIST_ADD_PRODUCT_DRAWER_CLOSE')
}

export function createFavoriteListAddProductDrawerOpenIntent(
  productSku: string,
  productName?: string,
  trackingEventCategory?: AddProductToFavoriteButtonProps['context'],
): WebViewIntent {
  return createIntent('FAVORITE_LIST_ADD_PRODUCT_DRAWER_OPEN', {
    productSku,
    productName,
    trackingEventCategory,
  })
}

export function createFavoriteListDetailsIntent(listId: number): WebViewIntent {
  return createIntent('FAVORITE_LIST_DETAILS', { listId })
}

export function createFavoriteListRemoveIntent(listId: number): WebViewIntent {
  return createIntent('FAVORITE_LIST_REMOVE', { listId })
}

export function createUpsertFavoritesListDrawerOpenIntent(listId?: number): WebViewIntent {
  return createIntent('FAVORITE_LIST_UPSERT_DRAWER_OPEN', { listId })
}

export function createFavoritesListRenamedIntent(): WebViewIntent {
  return createIntent('FAVORITE_LIST_RENAMED')
}

export function createUpsertFavoritesListDrawerCloseIntent(): WebViewIntent {
  return createIntent('FAVORITE_LIST_UPSERT_DRAWER_CLOSE')
}

export function createFavoriteListShareDrawerOpenIntent(listId: number): WebViewIntent {
  return createIntent('FAVORITE_LIST_SHARE_DRAWER_OPEN', { listId })
}

export function createFavoriteListShareDrawerCloseIntent(): WebViewIntent {
  return createIntent('FAVORITE_LIST_SHARE_DRAWER_CLOSE')
}
